import { initializeApp } from "firebase/app";
import { getFirestore } from 'firebase/firestore'; // Import getFirestore

const firebaseConfig = {
    apiKey: "AIzaSyDXZQS26GBSwXsUvD1_Ptqq8s5Jhr_2tcQ",
    authDomain: "javaapp-3e871.firebaseapp.com",
    projectId: "javaapp-3e871",
    storageBucket: "javaapp-3e871.appspot.com",
    messagingSenderId: "529305098481",
    appId: "1:529305098481:web:a81513f41d5801ece97150"
};

const app = initializeApp(firebaseConfig);
const db = getFirestore(app); // Initialize Firestore

export { db }; // Export the Firestore instance